import { createPopper } from "@popperjs/core";
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css"; // optional for styling
window.tippy = tippy;
window.createPopper = createPopper;
